export function updateSwiperSlideA11y(swiper, { onActiveSlide } = {}) {
  if (!swiper || !swiper.slides) return;

  swiper.slides.forEach((slide, index) => {
    const isActive = index === swiper.activeIndex;
    slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');

    slide
      .querySelectorAll('a, button, input, select, textarea')
      .forEach((el) => {
        el.tabIndex = isActive ? 0 : -1;
      });

    if (isActive && typeof onActiveSlide === 'function') {
      onActiveSlide(slide);
    }
  });
}

export function trapFocus(
  container,
  { additionalFocusable = [], onEscape, alsoBindTo = [] } = {}
) {
  if (!container) return () => {};

  const containerFocusable = Array.from(
    container.querySelectorAll('a, button')
  );
  const extra = Array.isArray(additionalFocusable)
    ? additionalFocusable.filter(Boolean)
    : [];
  const allFocusable = [...containerFocusable, ...extra];

  if (allFocusable.length === 0) return () => {};

  const handleKeyDown = (e) => {
    if (e.key === 'Escape' && typeof onEscape === 'function') {
      onEscape(e);
      return;
    }

    if (e.key !== 'Tab') return;
    const currentIndex = allFocusable.indexOf(document.activeElement);
    if (currentIndex === -1) return;

    if (e.shiftKey) {
      if (currentIndex === 0) {
        e.preventDefault();
        allFocusable[allFocusable.length - 1].focus();
      }
    } else if (currentIndex === allFocusable.length - 1) {
      e.preventDefault();
      allFocusable[0].focus();
    }
  };

  const extraTargets = Array.isArray(alsoBindTo) ? alsoBindTo.filter(Boolean) : [];

  container.addEventListener('keydown', handleKeyDown);
  extraTargets.forEach((t) => t.addEventListener('keydown', handleKeyDown));
  allFocusable[0].focus();

  return () => {
    container.removeEventListener('keydown', handleKeyDown);
    extraTargets.forEach((t) => t.removeEventListener('keydown', handleKeyDown));
  };
}

